import { toast } from "sonner";
import { trackWhatsAppClick } from "./analytics";

export const buildWhatsAppUrl = (phone, text) => {
  const num = String(phone || "").replace(/\D/g, "");
  const params = new URLSearchParams();
  if (text) params.set("text", text);
  const qs = params.toString();
  return `https://wa.me/${num}${qs ? `?${qs}` : ""}`;
};

/**
 * Open WhatsApp reliably across desktop/mobile + popup blockers.
 * - Tries window.open in a new tab
 * - Falls back to same-tab navigation if popup is blocked
 * - Shows a toast confirmation + a "copy number" fallback if both fail
 */
export const openWhatsApp = ({ phone, message, displayNumber, source } = {}) => {
  const url = buildWhatsAppUrl(phone, message);
  trackWhatsAppClick({ source: source || "cta" });
  try {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win && !win.closed) {
      toast.success("Opening WhatsApp…", {
        description: displayNumber ? `Chatting with ${displayNumber}` : undefined,
        duration: 2200,
      });
      return;
    }
    // Popup blocked — fallback to same-tab navigation
    window.location.href = url;
  } catch (_) {
    // Fallback: copy the number for manual messaging
    try {
      navigator.clipboard?.writeText(displayNumber || phone);
      toast(
        "Couldn't auto-open WhatsApp. The number has been copied — paste it in WhatsApp manually.",
        { duration: 7000 },
      );
    } catch {
      toast(
        `Couldn't open WhatsApp. Please message us at ${displayNumber || phone}.`,
        { duration: 7000 },
      );
    }
  }
};
